import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';

import { Table, Statistic, Row, Col } from 'antd';

class TrafficSignsStatesTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {}
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Vnitřní teplota [°C]"
              value={record.state.temperature} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Okolní osvětlení [%]"
              value={record.state.brightness} />
          </Col>
          <Col span={3}>
            <Statistic
              title="Síla signálu [%]"
              value={record.state.signal}
              precision={1} />
          </Col>
          <Col span={3}>
            <Statistic
              title="Uptime [h]"
              value={record.state.uptime / 60}
              precision={1} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Napájení"
              value={record.state.line} />
          </Col>
          <Col span={3}>
            <Statistic
              title="Napětí baterie [V]"
              value={record.state.voltage}
              precision={1} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Alarm baterie"
              value={record.state.alarm === true ? 'Ano' : 'Ne'} />
          </Col>
        </Row>
      </div >
    );
  }

  render() {
    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Seriové číslo',
      dataIndex: 'serialNumber',
      key: 'serialNumber',
      width: 170,
      sorter: (a, b) => defaultSorter(a.serialNumber, b.serialNumber),
    }, {
      title: 'Popis',
      dataIndex: 'description',
      key: 'description',
      width: 500,
    }, {
      title: 'Čas',
      dataIndex: 'createdAt',
      key: 'createdAt',
      defaultSortOrder: 'descend',
      sorter: (a, b) => dateSorter(a.createdAt, b.createdAt),
      render: (text, record) => (
        <span>{text ? moment(text).format('L LTS') : null}</span>
      ),
    }]

    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={columns}
        dataSource={this.props.data}
        style={{ border: '0px' }}
        onChange={this.handleChange}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
        expandedRowRender={this.expandedRowRender.bind(this)} />
    );
  }
}

export default TrafficSignsStatesTable;


// WEBPACK FOOTER //
// ./src/components/TrafficSignsStatesTable.js